import {
  PageHero,
  Reveal,
  SectionHead,
} from "@/components/Shared";
import { IMG, usePageContent } from "@/lib/api";
import { PAGES } from "@/content/pageContent";
import {
  HeartHandshake,
  Users,
  Globe,
  Handshake,
  Rocket,
  Trophy,
  Megaphone,
  BookOpen,
  Monitor,
  Compass,
} from "lucide-react";

const FOCUS_ICONS = [HeartHandshake, Users, Globe, Handshake, Rocket, Trophy, Megaphone, BookOpen, Monitor, Compass];

export default function About() {
  const c = usePageContent("about", PAGES.about.defaults);
  return (
    <main>
      <PageHero eyebrow="About Us" title="Who we are," italic="why we serve" image={IMG.forestMist} grotesk>
        <p className="text-sm leading-relaxed text-silver-dim sm:text-base">
          {c.heroText}
        </p>
      </PageHero>

      <section className="mx-auto max-w-7xl px-6 py-24" data-testid="about-rotaract">
        <div className="max-w-3xl">
          <SectionHead
            eyebrow="About Rotaract"
            title="What is Rotaract"
            grotesk
            description={c.whatIsRotaract}
          />
          <Reveal delay={0.2}>
            <div className="mt-10 space-y-6 text-sm leading-relaxed text-white sm:text-base">
              <p>
                <span className="font-semibold">{c.rcscwLead}</span> {c.rcscwBody}
              </p>
              <p>
                <span className="font-semibold">{c.connectionLead}</span> {c.connectionBody}
              </p>
              <p>
                <span className="font-semibold">{c.areasLead}</span> {c.areasBody}
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-28" data-testid="about-focus-areas">
        <SectionHead eyebrow="Our Focus Areas" title="Ten Avenues, One Fire" grotesk align="center" />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {c.focusAreas.map((f, i) => {
            const Icon = FOCUS_ICONS[i] || Compass;
            return (
              <Reveal key={`${f.title}-${i}`} delay={i * 0.05} className="h-full">
                <div className="card-line group flex h-full flex-col p-6" data-testid={`focus-area-${f.title.toLowerCase().replace(/\s+/g, "-")}`}>
                  <Icon size={24} strokeWidth={1.4} className="text-silver-dim transition-colors duration-300 group-hover:text-ember" />
                  <h3 className="mt-5 font-grotesk text-lg font-semibold tracking-tight text-silver">{f.title}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-silver-muted">{f.note}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </main>
  );
}
